import { render } from "./NavigationButtons.vue?vue&type=template&id=d02563b4&scoped=true"
import script from "./NavigationButtons.vue?vue&type=script&lang=js"
export * from "./NavigationButtons.vue?vue&type=script&lang=js"

import "./NavigationButtons.vue?vue&type=style&index=0&id=d02563b4&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d02563b4"]])

export default __exports__